import type React from 'react';
import { Rect } from 'react-native-svg';

import { usePlotDataContext } from './PlotDataProvider';
import { resolveColor } from './resolveColor';
import type { ExternalComponentProps } from './types';

interface GridBackgroundProps {
  fill?: string;
  gradientId?: string;
  opacity?: number;
}

type ExternalProps = ExternalComponentProps & GridBackgroundProps;

export const GridBackground: React.FC<ExternalProps> = (props) => {
  const { fill, gradientId, margin, baseHeight, baseWidth, opacity } =
    usePlotDataContext(props);

  const resolvedFill = resolveColor(fill, gradientId);

  return (
    <Rect
      fill={resolvedFill}
      opacity={opacity}
      fillOpacity={opacity}
      height={baseHeight - margin.top - margin.bottom}
      width={baseWidth - margin.left - margin.right}
      y={margin.top}
      x={margin.left}
    />
  );
};
